module.exports = __webpack_public_path__ + "static/media/dd.21ff9e40.png";